module.exports = __webpack_public_path__ + "static/media/original(1).0857e16c.png";